import React from 'react';
import { WfCartFramePreview } from '../components/frames/WfCartFramePreview';
import { siteConfig } from '../data/siteConfig';
export function Cart() {
  return <div className="mx-auto max-w-page px-5 py-14 md:px-10 md:py-20" data-id="element-568" data-mp="13fj55ef4qhgk">
      <h1 className="font-display text-[46px] font-medium leading-tight text-ink md:text-[60px]" data-id="element-569" data-mp="ygppbfcdeed8">Your Skincare Cart</h1>
      <div className="mt-12" data-id="element-570" data-mp="tlagj1t7z8no">
        <WfCartFramePreview data-id="element-571" data-mp="pi4a9u63xhh7" />
      </div>
      <p className="mt-12 text-[14px] text-ink-muted" data-id="element-572" data-mp="pj5mw32ruc11">
        Need help with your order? Call{' '}
        <a href={siteConfig.support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-573" data-mp="kpb73aqaeh78">
          {siteConfig.support.phone}
        </a>
        .
      </p>
    </div>;
}